module.exports = __webpack_public_path__ + "img/icon_6.0dc486eb.png";